<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon"><md-icon>local_shipping</md-icon></div>
          <h4 class="title">Shipping & Returns — Page Content</h4>
        </md-card-header>

        <md-card-content v-if="loading"><p>Loading...</p></md-card-content>
        <md-card-content v-else>

          <div class="cms-tabs">
            <button v-for="tab in tabs" :key="tab.key"
              :class="['tab-btn', { active: activeTab === tab.key }]"
              @click="activeTab = tab.key">{{ tab.label }}</button>
          </div>

          <!-- Hero -->
          <div v-if="activeTab === 'hero'" class="cms-section">
            <h5 class="section-label">Hero Section</h5>
            <md-field><label>Title</label><md-input v-model="form.hero.title" /></md-field>
            <md-field><label>Subtitle</label><md-input v-model="form.hero.subtitle" /></md-field>
          </div>

          <!-- Shipping Policies -->
          <div v-if="activeTab === 'shipping'" class="cms-section">
            <h5 class="section-label">Shipping Policy Items</h5>
            <div v-for="(item, i) in form.shippingPolicies" :key="i" class="array-card">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-25">
                  <md-field><label>Icon Class</label><md-input v-model="item.icon" placeholder="fas fa-truck" /></md-field>
                </div>
                <div class="md-layout-item md-size-30">
                  <md-field><label>Title</label><md-input v-model="item.title" /></md-field>
                </div>
                <div class="md-layout-item md-size-45">
                  <md-field><label>Content</label><md-textarea v-model="item.content" /></md-field>
                </div>
              </div>
              <md-button class="md-icon-button md-danger" @click="form.shippingPolicies.splice(i, 1)">
                <md-icon>delete</md-icon>
              </md-button>
            </div>
            <md-button class="md-success md-sm" @click="form.shippingPolicies.push({ icon: '', title: '', content: '' })">+ Add Item</md-button>
          </div>

          <!-- Return Policies -->
          <div v-if="activeTab === 'returns'" class="cms-section">
            <h5 class="section-label">Return Policy Items</h5>
            <div v-for="(item, i) in form.returnPolicies" :key="i" class="array-card">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-25">
                  <md-field><label>Icon Class</label><md-input v-model="item.icon" placeholder="fas fa-undo-alt" /></md-field>
                </div>
                <div class="md-layout-item md-size-30">
                  <md-field><label>Title</label><md-input v-model="item.title" /></md-field>
                </div>
                <div class="md-layout-item md-size-45">
                  <md-field><label>Content</label><md-textarea v-model="item.content" /></md-field>
                </div>
              </div>
              <md-button class="md-icon-button md-danger" @click="form.returnPolicies.splice(i, 1)">
                <md-icon>delete</md-icon>
              </md-button>
            </div>
            <md-button class="md-success md-sm" @click="form.returnPolicies.push({ icon: '', title: '', content: '' })">+ Add Item</md-button>
          </div>

        </md-card-content>
        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isSaving" @click="save">
            {{ isSaving ? 'Saving...' : 'Save Changes' }}
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import CmsService from "../../../services/CmsService";
export default {
  name: "ShippingPageCms",
  data() {
    return {
      loading: true, isSaving: false, activeTab: "hero",
      tabs: [
        { key: "hero",     label: "Hero" },
        { key: "shipping", label: "Shipping Policies" },
        { key: "returns",  label: "Return Policies" },
      ],
      form: { hero: { title: "", subtitle: "" }, shippingPolicies: [], returnPolicies: [] },
    };
  },
  methods: {
    load() {
      CmsService.getPage("shipping").then((r) => {
        const s = r.data.data.sections;
        this.form.hero             = s.hero             || this.form.hero;
        this.form.shippingPolicies = s.shippingPolicies || [];
        this.form.returnPolicies   = s.returnPolicies   || [];
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },
    save() {
      this.isSaving = true;
      CmsService.updatePage("shipping", { sections: this.form })
        .then(() => { this.$toast.success("Shipping page saved!"); this.isSaving = false; })
        .catch(() => { this.$toast.error("Save failed."); this.isSaving = false; });
    },
  },
  beforeMount() { this.load(); },
};
</script>

<style scoped>
.cms-tabs { display:flex; gap:8px; flex-wrap:wrap; border-bottom:2px solid #e2e8f0; margin-bottom:24px; }
.tab-btn { padding:10px 18px; border:none; background:transparent; font-size:14px; font-weight:500; color:#718096; cursor:pointer; border-bottom:3px solid transparent; margin-bottom:-2px; }
.tab-btn.active { color:#4caf50; border-bottom-color:#4caf50; font-weight:600; }
.cms-section { padding:8px 0 16px; }
.section-label { font-size:15px; font-weight:600; color:#2d3748; margin-bottom:20px; }
.array-card { background:#f8fafb; border:1px solid #e2e8f0; border-radius:10px; padding:16px; margin-bottom:12px; position:relative; }
</style>